import * as React from "react"
import { Center, Text } from "@chakra-ui/react"
import { API_URL, IS_LOCAL, IS_PROD, IS_TEST, LOCAL_API, PROD_API, TEST_API } from "../lib/config"

export function ProductionWarning() {
  if (IS_PROD && API_URL === PROD_API) return null
  if (IS_TEST && API_URL === TEST_API) return null

  if (IS_LOCAL && API_URL === LOCAL_API)
    return (
      <Center zIndex={1000} pos="fixed" top={0} left={0} bg="teal.600" w="100%" p={1}>
        <Text color="white" fontSize="xs" fontWeight="bold">
          You are using the local API url. If using a proxy, check its target endpoint.
        </Text>
      </Center>
    )

  if (API_URL === TEST_API)
    return (
      <Center zIndex={1000} pos="fixed" top={0} left={0} bg="yellow.600" w="100%" p={1}>
        <Text color="white" fontSize="xs" fontWeight="bold">
          You are using the testing API url.
        </Text>
      </Center>
    )

  if (API_URL === PROD_API)
    return (
      <Center zIndex={1000} pos="fixed" top={0} left={0} bg="red.600" w="100%" p={1}>
        <Text color="white" fontSize="xs" fontWeight="bold">
          You are using the production API url. Be careful.
        </Text>
      </Center>
    )

  return null
}
